import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

const EdgifySelect = ({
  options = [],
  currentOptionIndex = 0,
  onSelect = () => {},
  label,
  className,
}) => {
  return options.length > 1 ? (
    <FormControl variant="outlined" className={className}>
      <InputLabel>{label}</InputLabel>
      <Select value={currentOptionIndex} onChange={onSelect} label={label}>
        {options.map((option, i) => (
          <MenuItem value={i} key={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  ) : null;
};

export default EdgifySelect;
